<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo m-0">
          <img class="logo-dkp" src="logo.png" alt="logo TrendECommerce">
        </b-link>

        <b-card-title class="mb-1">
          Bem-vindo ao Ativadores de Vendas!
        </b-card-title>
        <b-card-text class="mb-2">
          Por favor, entre na sua conta e comece a aventura
        </b-card-text>

        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
          @submit.prevent="login"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent
          >

            <!-- email -->
            <b-form-group
              label-for="email"
              label="Email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required"
              >
                <b-form-input
                  id="email"
                  v-model="userEmail"
                  name="register-email"
                  :state="errors.length > 0 ? false:null"
                  placeholder="john@example.com"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">Senha</label>
                <b-link :href="resetPasswordLink" target="_blank">
                  <small>Esqueceu sua senha?</small>
                </b-link>
              </div>
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false:null"
                    name="register-password"
                    placeholder="Password"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- checkbox -->
            <b-form-group>
              <b-form-checkbox
                id="remember-me"
                v-model="status"
                name="checkbox-1"
              >
                Lembrar-me
              </b-form-checkbox>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
            >
              Entrar
            </b-button>

            <b-button
              variant="secondary"
              block
              @click="$router.push({ name: 'register' })"
            >
              Criar conta
            </b-button>
          </b-form>
        </validation-observer>

      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  BButton,
  BCard,
  BCardText,
  BCardTitle,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BLink,
} from 'bootstrap-vue'
import { email, required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import useJwt from '@/auth/jwt/useJwt'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: '',
      password: '',
      status: '',
      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    resetPasswordLink() {
      const mode = process.env.MODE_APP
      if (mode === 'prod') {
        return 'https://avmarket.com.br/auth/reset-password?adm'
      }
      // qualquer outro ambiente (dev, hml, etc)
      return 'https://hml.avmarket.com.br/auth/reset-password?adm'
    },
  },
  methods: {
    login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          useJwt.login({
            login: this.userEmail,
            senha: this.password,
          })
            .then(response => {
              const { accessToken, refreshToken, ...userData } = response.data
              useJwt.setToken(response.data.accessToken)
              useJwt.setRefreshToken(response.data.refreshToken)
              const baseAbility = { action: 'read', subject: 'Auth' }
              const abilities = [...(userData.ability || []), baseAbility]
              userData.ability = abilities
              localStorage.setItem('userData', JSON.stringify(userData))
              this.$store.commit('auth/SET_USER_DATA', userData)
              this.$ability.update(abilities)
              this.$router.replace(getHomeRouteForLoggedInUser(userData.role))
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: `Seja Bem vindo, ${userData.cliente?.nome || userData.nome_responsavel || ''}`,
                      icon: 'CoffeeIcon',
                      variant: 'success',
                      html: `Você se conectou com sucesso como  <strong>${userData.login}</strong>. Agora você pode começar a explorar!`,
                    },
                  })
                })
                .catch(() => {})
            })
            .catch(error => {
              console.log(error)
              const message = error.response?.data?.message || 'Erro ao fazer login'
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Erro de autenticação',
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: message,
                },
              })
              this.$refs.loginForm.setErrors(message)
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

</style>
